/*
 * Purpose: Routines design tokens — ported from ../autoblocks.ai/packages/design-tokens
 * Last modified: 2026-06-27 | Agent
 * Completeness: 95
 */

/** Calm teal accent — matches autoblocks.ai marketing brand */
export const routinesBrand = {
  accent: "#0d9488",
  accentHover: "#0f766e",
  accentSoft: "rgba(13, 148, 136, 0.12)",
} as const;

export const routinesColorTokens = {
  surface: {
    default: "#f4f6f9",
    muted: "#eceff4",
    elevated: "#ffffff",
  },
  text: {
    primary: "#111111",
    secondary: "#525252",
    inverse: "#ffffff",
  },
  accent: {
    default: "#111111",
    subtle: "#f5f5f5",
  },
  border: {
    default: "#e5e5e5",
  },
  status: {
    success: "#15803d",
    danger: "#b91c1c",
  },
  focus: {
    ring: "#2563eb",
  },
} as const;

export const routinesDarkColorTokens = {
  surface: {
    default: "#0a0a0a",
    muted: "#171717",
    elevated: "#171717",
  },
  text: {
    primary: "#fafafa",
    secondary: "#a3a3a3",
    inverse: "#111111",
  },
  accent: {
    default: "#fafafa",
    subtle: "#262626",
  },
  border: {
    default: "#404040",
  },
  status: {
    success: "#4ade80",
    danger: "#f87171",
  },
  focus: {
    ring: "#2563eb",
  },
} as const;

export const routinesTypography = {
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  radiusMd: "0.5rem",
  elevationSm: "0 1px 2px rgba(0, 0, 0, 0.06)",
  elevationHoverLg: "0 20px 48px rgba(0, 0, 0, 0.16)",
} as const;

export type DesignStyleId = "surface" | "routines";

export const DESIGN_STYLE_STORAGE_KEY = "autoblocks-design-style";

export const designStyleLabels: Record<DesignStyleId, string> = {
  surface: "Surface",
  routines: "Routines",
};
